import React from 'react';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import ConsoleUpcomingGame from '@/pages/intelligence/pages/Potential/UpcomingGames/ConsoleGame';

export default function Upcoming() {
  const pageLogInfo = dbiPageLogMes.topChartsConsoleGamesUpcoming;
  const entityType = 'console';
  return (
    <>
      <MarqueeBanner />
      <ConsoleUpcomingGame entityType={entityType} pageLogInfo={pageLogInfo} />
    </>
  );
}

